/**
 * Loading - Componente de carga genérico
 */

import React from 'react';
import { Loader2 } from 'lucide-react';

const Loading = ({ message = 'Cargando...', size = 'default' }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    default: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <Loader2 className={`${sizeClasses[size]} text-blue-600 animate-spin mb-3`} />
      <p className="text-gray-600">{message}</p>
    </div>
  );
};

export default Loading;



